<template>
  <label>
    <span class="label">{{ label }}{{ required ? "*" : "" }}</span>
    <v-text-field
      v-model="inputValue"
      class="mt-4 text-field"
      outlined
      dense
      clearable
      color="#FFA903"
      flat
      style="border-radius: 0 !important;"
      :placeholder="placeholder"
      :required="required"
      :name="name"
      :rules="rules"
      :type="type"
      @input="onInputChangeHandler"
    />
  </label>
</template>

<script>
export default {
  name: "InputField",
  props: ["value", "name", "label", "rules", "required", "type", "placeholder"],
  data() {
    return {
      inputValue: this.value
    };
  },
  methods: {
    onInputChangeHandler(value) {
      this.$emit("input", value);
    }
  }
};
</script>

<style scoped lang="scss">
@import "src/assets/style/vars";

.label {
  font-family: "Roboto", sans-serif;
  font-size: 16px;
  line-height: 1.15;
  font-weight: 700;
}
</style>
